import { Link } from "react-router-dom";
import StickyNavbar from "../navbar";
import * as motion from "motion/react-client"

const ChapterTwoOne = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const hoverEffect = {
    whileHover: { scale: 1.05 },
    transition: { duration: 0.3 },
  };

  return (
    <div>
      <StickyNavbar />

      <motion.div
        className="bg-white text-black p-4 lg:mt-10 mt-20 sm:p-10 lg:px-20 text-lg"
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <motion.div className="space-y-3" variants={fadeIn}>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center my-5 capitalize">
            Misconduct in research practice
          </h2>
          <p>
            Behaviours that go against the points we have just talked about when
            doing research ethically, either on purpose or because of
            carelessness, is called research misconduct(20-23). We should aim to
            avoid doing any of these things. This means during all stages of the
            research process, from the first research idea to when you report
            what you have found. Misconduct is set apart from making honest,
            human errors. Understanding research misconduct is important, as it
            encourages us to follow the above ethical guidelines, to make sure
            the trust and safety of our communities are protected. You can find
            some examples of these behaviours below, and what they mean.
          </p>
          <motion.ul
            className="list-disc list-inside space-y-3"
            variants={fadeIn}
          >
            <motion.li variants={fadeIn}>
              <b className="text-red-500">Fabrication:</b> Making up data or
              results and then presenting them as if they are real.
            </motion.li>
            <motion.li variants={fadeIn}>
              <b className="text-red-500">Falsification:</b> Manipulating
              research materials, data, or processes to create a false
              representation of results.
            </motion.li>
            <motion.li variants={fadeIn}>
              <b className="text-red-500">Plagiarism:</b> Using someone else’s
              ideas, words, or work and claiming it as your own.
            </motion.li>
            <motion.li variants={fadeIn}>
              <b className="text-red-500">
                Not getting the proper permission to do research:
              </b>{" "}
              When you want to do research, you usually need permission from
              someone, such as an ethical body, or someone in a higher-up role.
              Carrying out research without getting this first is misconduct.
            </motion.li>
            <motion.li variants={fadeIn}>
              <b className="text-red-500">No informed consent:</b> Not getting
              consent from participants or not properly informing them about the
              research before they agree to take part.
            </motion.li>
            <motion.li variants={fadeIn}>
              <b className="text-red-500">Conflict of interest:</b> Not being
              honest about personal interests that could affect the research.
            </motion.li>
            <motion.li variants={fadeIn}>
              <b className="text-red-500">Sabotage:</b> Deliberately damaging or
              holding back someone else's research.
            </motion.li>
            <motion.li variants={fadeIn}>
              <b className="text-red-500">
                Poor management of research projects:
              </b>{" "}
              Lack of properly managing or planning the research can harm the
              quality of the research and put participant safety at risk.
            </motion.li>
          </motion.ul>
        </motion.div>
          <motion.div
                    className=" rounded-lg p-4"
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="flex justify-center">
                      <img
                        src="/images/chp2-1.svg"
                        alt="Community health worker engaging with locals"
                        className="w-full max-w-md rounded-md"
                      />
                    </div>
                   
                  </motion.div>

        <div className="flex justify-between mt-10">
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ duration: 0.2 }}
          >
            <Link to="/chapter2/principles">
              <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                Previous
              </button>
            </Link>
          </motion.div>
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ duration: 0.2 }}
          >
            <Link to="/chapter2/sectionTwo">
              <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                Next
              </button>
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default ChapterTwoOne;
